import script from "./AgentTypeSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentTypeSelector.vue?vue&type=script&setup=true&lang=js"

import "./AgentTypeSelector.vue?vue&type=style&index=0&id=70ef4e04&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70ef4e04"]])

export default __exports__